function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M287.932,347.793c-11.87-0.026-23.262,4.693-31.633,13.107l-2.5,2.5l-2.5-2.5c-17.468-17.468-45.798-17.468-63.266,0 s-17.468,45.798,0,63.266l59.733,59.733c3.328,3.328,8.738,3.328,12.066,0l59.733-59.733c17.468-17.476,17.468-45.798-0.009-63.275 C311.168,352.503,299.793,347.793,287.932,347.793z M307.499,412.1l-53.7,53.7l-53.7-53.7 c-10.931-10.684-11.127-28.203-0.444-39.134s28.203-11.127,39.134-0.444c0.154,0.145,0.299,0.29,0.444,0.444l8.533,8.533 c3.328,3.328,8.738,3.328,12.066,0l8.533-8.533c10.948-10.453,28.186-10.453,39.134,0 C318.293,383.778,318.293,401.289,307.499,412.1z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.2,128h68.267c4.71,0,8.533-3.823,8.533-8.533v-76.8c0-4.71-3.823-8.533-8.533-8.533H115.2 c-4.71,0-8.533,3.823-8.533,8.533v76.8C106.667,124.177,110.49,128,115.2,128z M123.733,51.2h51.2v59.733h-51.2V51.2z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M217.6,128h68.267c4.71,0,8.533-3.823,8.533-8.533v-76.8c0-4.71-3.823-8.533-8.533-8.533H217.6 c-4.71,0-8.533,3.823-8.533,8.533v76.8C209.067,124.177,212.89,128,217.6,128z M226.133,51.2h51.2v59.733h-51.2V51.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M320,128h68.267c4.71,0,8.533-3.823,8.533-8.533v-76.8c0-4.71-3.823-8.533-8.533-8.533H320c-4.71,0-8.533,3.823-8.533,8.533 v76.8C311.467,124.177,315.29,128,320,128z M328.533,51.2h51.2v59.733h-51.2V51.2z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.2,238.933h68.267c4.71,0,8.533-3.823,8.533-8.533v-76.8c0-4.71-3.823-8.533-8.533-8.533H115.2 c-4.71,0-8.533,3.823-8.533,8.533v76.8C106.667,235.11,110.49,238.933,115.2,238.933z M123.733,162.133h51.2v59.733h-51.2V162.133z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M217.6,238.933h68.267c4.71,0,8.533-3.823,8.533-8.533v-76.8c0-4.71-3.823-8.533-8.533-8.533H217.6 c-4.71,0-8.533,3.823-8.533,8.533v76.8C209.067,235.11,212.89,238.933,217.6,238.933z M226.133,162.133h51.2v59.733h-51.2V162.133z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M320,238.933h68.267c4.71,0,8.533-3.823,8.533-8.533v-76.8c0-4.71-3.823-8.533-8.533-8.533H320 c-4.71,0-8.533,3.823-8.533,8.533v76.8C311.467,235.11,315.29,238.933,320,238.933z M328.533,162.133h51.2v59.733h-51.2V162.133z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M462.891,355.558c1.621-1.809,2.389-4.215,2.125-6.63l-8.533-76.8c-0.478-4.326-4.13-7.595-8.482-7.595h-17.067v-256 c0-4.71-3.823-8.533-8.533-8.533H81.067c-4.71,0-8.533,3.823-8.533,8.533v239.718l-16.666-0.785 c-2.33-0.128-4.608,0.725-6.289,2.347c-1.69,1.613-2.645,3.849-2.645,6.187v42.667c0,4.301,3.209,7.927,7.475,8.465l18.125,2.27 v194.065c0,4.71,3.823,8.533,8.533,8.533H422.4c4.71,0,8.533-3.823,8.533-8.533V358.4h25.6 C458.957,358.4,461.269,357.367,462.891,355.558z M72.533,292.198L64,291.132v-26.189l8.533,0.393V292.198z M89.6,266.129 l320.691,14.925l-19.115,50.978L89.6,294.332V266.129z M413.867,349.867v145.067H89.6V311.535l306.142,38.263 c0.35,0.043,0.708,0.068,1.058,0.068c3.558,0,6.733-2.202,7.987-5.53l9.079-24.201V349.867z M413.867,264.124L89.6,249.045V17.067 h324.267V264.124z M430.933,341.333V281.6h9.387l6.647,59.733H430.933z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var _ref19 =
/*#__PURE__*/
React.createElement("g", null);

var _ref20 =
/*#__PURE__*/
React.createElement("g", null);

var _ref21 =
/*#__PURE__*/
React.createElement("g", null);

var _ref22 =
/*#__PURE__*/
React.createElement("g", null);

var _ref23 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), React.createElement("path", {
    style: {
      "fill": "#956D4F"
    },
    d: "M422.4,8.533v264.533L81.067,257.195V8.533H422.4z M388.267,230.4v-76.8H320v76.8H388.267z M388.267,119.467v-76.8H320v76.8H388.267z M285.867,230.4v-76.8H217.6v76.8H285.867z M285.867,119.467v-76.8H217.6v76.8H285.867z M183.467,230.4v-76.8H115.2v76.8H183.467z M183.467,119.467v-76.8H115.2v76.8H183.467z"
  }), React.createElement("g", null, React.createElement("rect", {
    x: 320,
    y: 42.667,
    style: {
      "fill": "#624431"
    },
    width: 68.267,
    height: 76.8
  }), React.createElement("rect", {
    x: 217.6,
    y: 42.667,
    style: {
      "fill": "#624431"
    },
    width: 68.267,
    height: 76.8
  }), React.createElement("rect", {
    x: 115.2,
    y: 42.667,
    style: {
      "fill": "#624431"
    },
    width: 68.267,
    height: 76.8
  }), React.createElement("rect", {
    x: 115.2,
    y: 153.6,
    style: {
      "fill": "#624431"
    },
    width: 68.267,
    height: 76.8
  }), React.createElement("rect", {
    x: 217.6,
    y: 153.6,
    style: {
      "fill": "#624431"
    },
    width: 68.267,
    height: 76.8
  }), React.createElement("rect", {
    x: 320,
    y: 153.6,
    style: {
      "fill": "#624431"
    },
    width: 68.267,
    height: 76.8
  })), React.createElement("g", null, React.createElement("polygon", {
    style: {
      "fill": "#B9B9B9"
    },
    points: "448,273.067 456.533,349.867 422.4,349.867 422.4,273.067 \t"
  }), React.createElement("polygon", {
    style: {
      "fill": "#B9B9B9"
    },
    points: "422.4,273.067 396.8,341.333 81.067,301.909 81.067,301.824 55.467,298.667 55.467,256  81.067,257.195 \t"
  })), React.createElement("path", {
    style: {
      "fill": "#ECECEC"
    },
    d: "M422.4,503.467H81.067V301.909L396.8,341.333l25.6-68.267V503.467z M253.781,477.867l59.733-59.733 c13.952-14.319,13.653-37.248-0.666-51.2c-14.063-13.696-36.471-13.696-50.534,0l-8.533,8.533l-8.533-8.533 c-14.319-13.952-37.248-13.653-51.2,0.666c-13.696,14.063-13.696,36.471,0,50.534L253.781,477.867z"
  }), React.createElement("path", {
    style: {
      "fill": "#C60024"
    },
    d: "M313.515,366.933c14.14,14.097,14.165,36.992,0.068,51.132c-0.026,0.026-0.043,0.043-0.068,0.068 l-59.733,59.733l-59.733-59.733c-13.952-14.319-13.653-37.248,0.666-51.2c14.063-13.696,36.471-13.696,50.534,0l8.533,8.533 l8.533-8.533C276.463,352.828,299.366,352.828,313.515,366.933z"
  }), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

export default __webpack_public_path__ + "static/media/chocolate.a285d226.svg";
export { SvgComponent as ReactComponent };